import { useCallback } from 'react';

export const useScrollToWindow = () => {
  const scrollToWindowTop = useCallback(
    ({ smooth = false }: { smooth?: boolean }) => {
      window.scrollTo({
        top: 0,
        behavior: smooth ? 'smooth' : 'auto',
      });
    },
    [],
  );

  const scrollToWindowBottom = useCallback(
    ({ smooth = false }: { smooth?: boolean }) => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: smooth ? 'smooth' : 'auto',
      });
    },
    [],
  );

  return { scrollToWindowTop, scrollToWindowBottom };
};
